import React from 'react';
import { select } from 'd3-selection';
import './fov-diagram.css';


class FieldOfViewDiagram extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      heightUpPost: props.heightUpPost || 3,
      laneWidth: props.laneWidth || 3,
      numLanes: props.numLanes || 2,
      pavWidth: props.pavWidth || 1,  
      pavHeight: props.pavHeight || 0.12, 
      mountAngle: props.mountAngle || 38, 
      fovAngle: props.fovAngle || 16 
    };

    this.svg;
    this.postRect;
    this.pavRect;
    this.viewTri;
  }

 
  componentDidMount() {
    this.initDiagram();
    this.fullUpdate(this.state);
  }  



  componentWillReceiveProps(nextProps) {
    // console.log('New props');
    // console.log(nextProps);
    // TODO: Only update the parts of the diagram that I need to rather than the whole thing?
    // TODO: Also check if the new props are even different to the current values (see: https://reactjs.org/blog/2016/01/08/A-implies-B-does-not-imply-B-implies-A.html).
    // TODO: There may be a better practise for applying these updates. In later versions of react the getDerivedStateFromProps method seems to be the better way of doing it.
    this.setState(nextProps, () => {
      this.fullUpdate(this.state);
    });
  }


  initDiagram() {

    const node = this.node;
    this.svg = select(node);    

    // Lamppost
    this.postRect = this.svg.append('rect');

    // Pavement
    this.pavRect  = this.svg.append('rect')
      .style('fill', 'grey');

    // Field of view triangle
    this.viewTri = this.svg.append('polygon')
      .style('fill', '#00BFF3')     // remove any fill colour
      .style('opacity', 0.5);

  }



  fullUpdate(sizes) {

    // What is the width and height of the svg element so we can adjust sizes accordingly
    const svgWidth  = this.convertD3dimension(this.svg.style('width'));
    const svgHeight = this.convertD3dimension(this.svg.style('height'));
    // console.log(`SVG width is ${svgWidth}, height is ${svgHeight}`);

    // How many metres across will everything total up to
    const postWidth = 0.15; // in metres
    const metresAcross = postWidth + sizes.pavWidth + (sizes.laneWidth * sizes.numLanes);
    // ... and how many metres tall
    const minPostHeight = 5;
    const postHeight = sizes.heightUpPost > minPostHeight ? (sizes.heightUpPost + 1) : minPostHeight;
    const metresTall = postHeight + sizes.pavHeight;

    // Calculate the scaling we should use so that it'll all fit in.
    const xScaling = svgWidth / metresAcross;
    const yScaling = svgHeight / metresTall;
    const s = xScaling > yScaling ? yScaling : xScaling;
    // console.log('Scaling is:' + s);

    // Calculate the width of the pavement plus the width of the lamppost (in metres)
    const pavPlusPostWidth = sizes.pavWidth + postWidth;

    // Update the post
    this.postRect
      .attr('width', postWidth * s)
      .attr('height', postHeight * s)
      .attr('y', svgHeight - ((sizes.pavHeight + postHeight) * s));

    // Update the Pavement
    this.pavRect
      .attr('width', pavPlusPostWidth * s)
      .attr('height', sizes.pavHeight * s)
      .attr('x', 0)
      .attr('y', svgHeight - (sizes.pavHeight * s));

    // Update fov triangle
    // Work out the coordinates of each of the points (in pixels)
    // Where is sensor
    const startX = postWidth * s;
    const startY = svgHeight - ((sizes.heightUpPost + sizes.pavHeight) * s);
    // Find the angles between the vertical post and diagonal lines marking the edge of the field of views
    const leftAngle = sizes.mountAngle - (sizes.fovAngle / 2);
    const rightAngle = sizes.mountAngle + (sizes.fovAngle / 2);
    // Where does the left-hand side of the FoV intesect with the road
    const leftX = (this.calcOpposite(sizes.heightUpPost + sizes.pavHeight, leftAngle) + postWidth) * s;
    const leftY = svgHeight;
    // Where does the right-hand side of the FoV intesect with the road
    const rightX = (this.calcOpposite(sizes.heightUpPost + sizes.pavHeight, rightAngle) + postWidth) * s;
    const rightY = svgHeight;

    // the points are in the format x,y
    this.viewTri
      .attr('points', ' ' + startX + ',' + startY + ',' +
                      leftX + ',' + leftY + ','  +
                      rightX + ',' + rightY);


    // Update lane markers
    // Calculate properties of each marker
    var laneMarkData = [];
    for (var i = 1; i <= sizes.numLanes; i++) {

      var markHeight = 10;   // (in pixels)
      var markWidth = 5;     // (in pixels)

      laneMarkData.push({
        x: (pavPlusPostWidth * s) + (i * sizes.laneWidth * s) - (markWidth / 2),
        y: svgHeight - markHeight,
        width: markWidth,
        height: markHeight
      });

    }

    // Remove any existing marks first
    this.svg.selectAll('.markRect').remove();

    this.svg.selectAll('.markRect')
      .data(laneMarkData)
      .enter().append('rect')
      .attr('class', 'markRect')
      .attr('x', function(d) {return d.x;})
      .attr('y', function(d) {return d.y;})
      .attr('width', function(d) {return d.width;})
      .attr('height', function(d) {return d.height;});

  }


  // When you ask d3 to find the height or width it returns a value in the format '100px', the function removes the 'px' and converts it to a number
  convertD3dimension(str) {
    return Number(str.replace('px', ''));
  }

  // Degrees to radians
  toRadians(angle) {
    return angle * (Math.PI / 180);
  }

  // Find the length of the opposite side of a triangle given the adjacent and the angle in degrees. This is useful for calculating the distance along the ground from the base of the post to edges of the field of view cone.
  calcOpposite(adjLength, angleInDeg) {
    return adjLength * (Math.tan(this.toRadians(angleInDeg)));
  }


  render() {
    return (
      <div>
        <svg ref={node => this.node = node} className="fov-diagram"></svg>
      </div>
    );
  }

}


export default FieldOfViewDiagram;


// WEBPACK FOOTER //
// ./src/components/FieldOfViewDiagram/index.js